export type AppearancePreference = "system" | "light" | "dark";

export function getAppearancePreference(): AppearancePreference {
	const preference = document.documentElement.dataset.appearance;
	return preference === "light" || preference === "dark" ? preference : "system";
}

export function applyAppearance(preference: AppearancePreference): void {
	document.documentElement.dataset.appearance = preference;
}
